export default "__VITE_ASSET__CTP0EX_g__"